(function () {
	"use strict";

	angular
		.module("app.account")
		.controller("AccountController", AccountController);

	AccountController.$inject = ["$scope", "$timeout", "AccountService"];

	function AccountController($scope, $timeout, AccountService) {
		/* jshint validthis:true */
		var vm = this;

		function activate() {
			vm.accountLoading = true;
			$timeout(function () {
				AccountService.getUser()
					.then(function (result) {
						vm.user = result;
						vm.accountLoading = false;
					}).catch(function (err) {
						vm.accountLoading = false;
					});
			});
		}

		activate();
	}
})();